import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useForumBuildingsQuery = getWrappedUseQuery(KEYS.GET_FORUM_BUILDINGS, apiClient.ForumBuilding.get);
